import {
  isRouteErrorResponse,
  Links,
  Meta,
  Scripts,
  useRouteError,
} from '@remix-run/react'
import {
  defaultErrorDescription,
  errorDescriptions,
} from '~/constants/error-descriptions'
import type {ReactNode} from 'react'

// WIP, Remix v2 ErrorBoundary
export function ErrorBoundary() {
  const error = useRouteError()

  if (isRouteErrorResponse(error)) {
    const errorDescription = errorDescriptions[error.status]

    return (
      <Document>
        <div className="prose prose-sm mx-auto prose-h1:text-xl">
          <h1>
            {error.status} {errorDescription?.title}
          </h1>
          {errorDescription?.description}
        </div>
      </Document>
    )
  } else {
    return (
      <Document>
        <div className="prose prose-sm mx-auto prose-h1:text-xl">
          <h1>{defaultErrorDescription.title}</h1>
          {defaultErrorDescription.description}
        </div>
      </Document>
    )
  }
}

export const Document = ({children}: {children: ReactNode}) => {
  return (
    <html lang="en">
      <head>
        <title>Oh no!</title>
        <Meta />
        <Links />
      </head>
      <body>
        {children}
        <Scripts />
      </body>
    </html>
  )
}
